import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "preview", "iframe"]

  connect() {
    // Controller ist verbunden
  }

  toggle(event) {
    const button = event.currentTarget
    const filename = button.dataset.filename
    const previewContainer = this.previewTargets.find(preview => 
      preview.closest('.mb-3').querySelector('[data-filename="' + filename + '"]') === button
    )
    
    if (previewContainer) {
      const iframe = previewContainer.querySelector('[data-pdf-preview-target="iframe"]')
      
      if (previewContainer.classList.contains('hidden')) {
        // Vorschau öffnen
        previewContainer.classList.remove('hidden')
        button.querySelector('i').classList.remove('fa-eye')
        button.querySelector('i').classList.add('fa-eye-slash')
        
        // PDF in iframe laden
        if (iframe && iframe.dataset.src && !iframe.src) {
          iframe.src = iframe.dataset.src
        }
      } else {
        // Vorschau schließen
        previewContainer.classList.add('hidden')
        button.querySelector('i').classList.remove('fa-eye-slash')
        button.querySelector('i').classList.add('fa-eye')
      }
    }
  }
}
